import plusIcon from "../assets/svg/plus-table.svg";
import InstallmentIcon from "../assets/icons/installment.png";
import { apiDeleteInstallments, apiGetInstallments } from "../api/installmentApi";
import { formatPrice } from "../helpers";
import { openInstallmentDrawer } from "helpers/DrawerActions";
import { apiGetInstallmentsReport } from "api/reportApi";
// import StatusComponent from "components/installment2/show/installmetStstusComponent";
import getCurrency from "helpers/currencyHelper";
import StatusComponent from "components/installment2/list/component/statusComponent";
import { searchType } from "./FactorForm";

const defaultTableColumns = [
    {
        name: "مشتری",
        key: "Person",
        getValue: (item) => {
            return item.Factor?.Person?.nickName ?? "-";
        },
        searchType: "autocomplete",
        dataKey: {
            column: "persons",
            key: "nickName",
        },
    },
    {
        name: "مبلغ فاکتور",
        key: "totalPrice",
        price: true,
        searchType: "quantitative",
    },
    {
        name: "پیش پرداخت",
        key: "prepayment",
        price: true,
        searchType: "quantitative",
    },
    {
        name: "سود",
        key: "profit",
        price: true,
        searchType: "quantitative",
    },
    {
        name: "مجموع پرداخت",
        key: "totalPaid",
        price: true,
        searchType: "quantitative",
    },
    {
        name: "تعداد اقساط",
        key: "quantity",
        searchType: "quantitative",
    },
    {
        name: "میانگین اقساط",
        key: "amount",
        getValue: (item) => {
            const totalInstallmentsPrice =
                item.installments?.reduce((sum, item) => {
                    return sum + +(item.price ?? 0);
                }, 0) ?? 0;
            const installmentsQuantity = item.installments?.length ?? 1;

            return formatPrice(totalInstallmentsPrice / installmentsQuantity);
        },
        searchType: "quantitative",
    },
];

export const installmentIndexData = [
    {
        title: "فروش",
        description: "",
        key: "installmentSale",
        label: "فروش",
        pluralLabel: "فروش ها",
        pageTitle: "فروش اقساطی",
        pageDescription: "لیست فروش های اقساطی کسب و کار",
        tableColumns: defaultTableColumns,
        disableDateFilter: true,
        actions: {
            add: {
                title: "ثبت",
                icon: plusIcon,
                url: "/installments/add",
            },
            fetch: apiGetInstallments,
            delete: apiDeleteInstallments,
            edit: {},
            // copy: true,
            // excel: {
            //     export: apiGetInstallmentsExcel,
            // },
            view: {
                // url: "/factors/view",
                id: "factorId",
                label: "مشاهده اقساط",
                openDrawer: openInstallmentDrawer,
            },
            archive: {
                model: 'installment'
            }
        },
    },
    {
        title: "خرید",
        description: "",
        key: "installmentBuy",
        label: "خرید",
        pluralLabel: "خرید ها",
        pageTitle: "خرید اقساطی",
        pageDescription: "لیست خرید های اقساطی کسب و کار",
        tableColumns: defaultTableColumns,
        disableDateFilter: true,
        actions: {
            add: {
                title: "ثبت",
                icon: plusIcon,
                url: "/installments/add",
            },
            edit: {},
            fetch: apiGetInstallments,
            delete: apiDeleteInstallments,
            // copy: true,
            // excel: {
            //     export: apiGetInstallmentsExcel,
            // },
            view: {
                // url: "/factors/view",
                id: "factorId",
                label: "مشاهده اقساط",
                openDrawer: openInstallmentDrawer,
            },
            archive: {
                model: 'installment'
            }
        },
    },
];

export const installmentFormData = {
    installment: {
        title: "اقساط",
        navigation: {
            title: "ثبت اقساط",
            // description: 'ثبت اطلاعات شخص',
            backTitle: "بازگشت",
            backUrl: "/installments",
        },
        tabs: [
            {
                key: "installmentSale",
                name: "فروش",
            },
            {
                key: "installmentBuy",
                name: "خرید",
            },
        ],
        installmentSale: {
            key: "installmentSale",
            name: "فروش",
            sourceName: "اقساط",
            hasFactor: true,
            factorTypes: '["sale"]',
            sourceOptions: [
                {
                    formType: "installment",
                    key: "installment",
                    index: 0,
                    title: "قسط",
                    logo: InstallmentIcon,
                    options: "customers",
                },
            ],
            inputs: [
                {
                    formType: "installment",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    type: "conditionalPriceInput",
                    name: "prepayment",
                    label: "پیش پرداخت",
                    required: true,
                },
                {
                    formType: "installment",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    type: "conditionalPriceInput",
                    name: "profit",
                    label: "سود",
                    required: true,
                },
                {
                    formType: "installment",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    type: "datePickerInput",
                    name: "firstDueDate",
                    label: "سررسید اولین قسط",
                    required: true,
                },
                {
                    formType: "installment",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    type: "number",
                    name: "interval",
                    label: "فاصله اقساط (روز)",
                    maxLength: 3,
                    placeholder: 12,
                    required: true,
                },
                {
                    formType: "installment",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    type: "number",
                    name: "quantity",
                    label: "تعداد اقساط",
                    maxLength: 3,
                    placeholder: 12,
                    required: true,
                },
                {
                    formType: "installment",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    name: "description",
                    label: "توضیحات",
                },
                // {
                //     formType: "installment",
                //     outerWrapperClass: 'col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left',
                //     type: 'selectBox',
                //     addModal: {
                //         props: {
                //             component: 'branch',
                //             title: 'افزودن شعبه',
                //             closeButton: true,
                //             onFinish: (token) => apiGetBranches(token),
                //         },
                //     },
                //     name: 'Branch',
                //     label: 'شعبه',
                //     showInput: true,
                //     options: 'branches'
                // },
                // {
                //     formType: "installment",
                //     outerWrapperClass: 'col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left',
                //     type: 'selectBox',
                //     addModal: {
                //         props: {
                //             component: 'project',
                //             title: 'افزودن پروژه',
                //             closeButton: true,
                //             onFinish: (token) => apiGetProjects(token),
                //         },
                //     },
                //     name: 'Project',
                //     label: 'پروژه',
                //     showInput: true,
                //     options: 'projects'
                // },
            ],
        },
        installmentBuy: {
            key: "installmentBuy",
            name: "خرید",
            sourceName: "اقساط",
            hasFactor: true,
            factorTypes: '["buy"]',
            sourceOptions: [
                {
                    formType: "installment",
                    key: "installment",
                    index: 0,
                    title: "اقساط",
                    logo: InstallmentIcon,
                    options: "customers",
                },
            ],
            inputs: [
                {
                    formType: "installment",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    type: "conditionalPriceInput",
                    name: "prepayment",
                    label: "پیش پرداخت",
                    required: true,
                },
                {
                    formType: "installment",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    type: "conditionalPriceInput",
                    name: "profit",
                    label: "سود",
                    required: true,
                },
                {
                    formType: "installment",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    type: "datePickerInput",
                    name: "firstDueDate",
                    label: "سررسید اولین قسط",
                    required: true,
                },
                {
                    formType: "installment",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    type: "number",
                    name: "interval",
                    label: "فاصله اقساط (روز)",
                    maxLength: 3,
                    placeholder: 12,
                    required: true,
                },
                {
                    formType: "installment",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    type: "number",
                    name: "quantity",
                    label: "تعداد اقساط",
                    maxLength: 3,
                    placeholder: 12,
                    required: true,
                },
                {
                    formType: "installment",
                    outerWrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-fields-right style-fields-left",
                    name: "description",
                    label: "توضیحات",
                },

            ],
        },
    },
};

export const installmentReportColumn = [
    {
        name: "عنوان",
        key: "title",
        columnType: "string",
        model: 'installmentItem'

    },
    {
        name: "تاریخ سر رسید",
        key: "dueDate",
        getValue: (item) => `${item?.type === "prepayment" ? "" : item.dueDate}`,
        columnType: "date",
        model: 'installmentItem',
        filterParams: {
            column: "date",
            columnType: "date",
        },
        searchType: searchType.date,


    },
    {
        name: "شخص",
        key: "nickName",
        getValue: (item) => item.payer?.nickName,
        columnType: "string",
        model: 'person'

    },

    {
        name: "مبلغ قسط",
        key: "price",
        columnType: "number",

        getValue: (item) =>
            `${formatPrice(item?.price || 0)} ${item?.Installment.Currency?.en_title || getCurrency().defCur.en_title}`,
        model: 'installmentItem'

    },
    {
        name: "مانده",
        columnType: "number",
        key: "remain",
        getValue: (item) =>
            `${formatPrice(item?.remain || 0)} ${item?.Installment.Currency?.en_title || getCurrency().defCur.en_title}`,
        model: 'installmentItem'

    },
    {
        name: "پرداخت شده",
        columnType: "number",

        key: "pay",
        getValue: (item) =>
            `${formatPrice(item?.pay || 0)} ${item?.Installment.Currency?.en_title || getCurrency().defCur.en_title}`,
        model: 'installmentItem'

    },
    {
        name: "جریمه دیرکرد",
        key: "lateFees",
        columnType: "number",
        getValue: (item) =>
            item?.type === "prepayment"
                ? ""
                : `${formatPrice(item?.lateFeesPrice || 0)} ${item?.Installment.Currency?.en_title || getCurrency().defCur.en_title}`,
        model: 'installmentItem'

    },


]


export const installmentsShowTable = [
    {
        title: "نمایش تمامی اقساط",
        // description: "",
        key: "installmentShow_R",
        pageTitle: "گزارش اقساط",

        label: "دریافتی",
        pageTitle: "",
        pageDescription: "",
        pluralLabel: "",
        tableColumns: installmentReportColumn,
        actions: {
            fetch: apiGetInstallmentsReport
        },
    },
    {
        title: "اقساط پرداخت شده",
        // description: "",
        key: "completed_R",
        pageTitle: "گزارش اقساط ",

        label: "اقساط پرداخت شده",
        pageTitle: "",
        pageDescription: "",
        pluralLabel: "",
        tableColumns: installmentReportColumn,
        actions: { fetch: apiGetInstallmentsReport },
    },
    {
        title: "اقساط پرداخت ناقص",
        // description: "",
        key: "ongoing_R",
        pageTitle: "گزارش اقساط ",

        label: "اقساط پرداخت ناقص",
        pageTitle: "",
        pageDescription: "",
        pluralLabel: "",
        tableColumns: installmentReportColumn,
        actions: { fetch: apiGetInstallmentsReport },
    },
    {
        title: "اقساط سررسید نشده",
        // description: "",
        key: "notPassed_R",
        pageTitle: "گزارش اقساط ",

        label: "اقساط سررسید نشده",
        pageTitle: "",
        pageDescription: "",
        pluralLabel: "",
        tableColumns: installmentReportColumn,
        actions: { fetch: apiGetInstallmentsReport },
    },
    {
        title: "اقساط پرداخت نشده",
        // description: "",
        key: "passed_R",
        pageTitle: "گزارش اقساط 0",

        label: "اقساط پرداخت شده",
        pageTitle: "",
        pageDescription: "",
        pluralLabel: "",
        tableColumns: installmentReportColumn,
        actions: { fetch: apiGetInstallmentsReport },
    },
];
